import { ProductGroup } from "./product.group";
import { SubProduct } from "./subproduct";
import { ProductBehaviour } from "./product_behaviour";

export class Field<T> {
    index: number;
    value: T;

    constructor(index: number, val?: T) {
        this.index = index;
        this.value = val;
    }

    setValue(val: T) {
        this.value = val;
    }

    /**
     *
     * @returns {T}
     */
    getValue() {
        return this.value;
    }

    /**
     *
     * @returns {string}
     */
    getType() {
        return typeof (this.value);
    };
}

export interface ProductSelectedEvent {
    productGroup: ProductGroup,
    product: Product,
    subProduct: SubProduct
}

interface ProductInterface {
    id: Field<number>;
    articleNumber: Field<string>;
    title: Field<string>;
    subtitle1: Field<string>;
    subtitle2: Field<string>;
    description: Field<string>;
    price: Field<number>;
    thumbPath: Field<string>;
    thumbPath1: Field<string>;
    thumbPath2: Field<string>;
    renderPath: Field<string>;
    renderPath1: Field<string>;
    renderPath2: Field<string>;
    isSelected: boolean;
    filters?: Array<{ type: string, value: any }>;
    url: Field<string>;
}

export class Product implements ProductInterface, ProductBehaviour {
    id: Field<number>;
    articleNumber: Field<string>;
    title: Field<string>;
    subtitle1: Field<string>;
    subtitle2: Field<string>;
    description: Field<string>;
    price: Field<number>;
    thumbPath: Field<string>;
    thumbPath1: Field<string>;
    thumbPath2: Field<string>;
    renderPath: Field<string>;
    renderPath1: Field<string>;
    renderPath2: Field<string>;
    isSelected: boolean;
    filters?: Array<{ type: string, value: any }> = [];
    url: Field<string>;

    constructor(data: any, private filterBy: Array<any>, private group?: ProductGroup) {
        this.initFields(data);
    }

    public registerInGroup(group: ProductGroup) {
        this.group = group;
        return this;
    }

    /**
     *
     * @param index {number}
     * @returns {any|Field}
     */
    private getFieldByIndex(index) {
        for (let fieldName in this) {
            if (this.hasOwnProperty(fieldName) && this[fieldName] instanceof Field) {
                let field = <Field<any>><any>this[fieldName];
                if (field.index === index) {
                    return field;
                }
            }
        }
        return null;
    }

    public getGroup(): ProductGroup {
        return this.group;
    }

    public getGroupName() {
        return this.group.getName();
    }

    private initFields(data: any) {
        this.id = new Field<number>(0, parseInt(data.ID));
        this.articleNumber = new Field<string>(1, data.ArticleNumber);
        this.title = new Field<string>(2, data.Title);
        this.subtitle1 = new Field<string>(3, data.Subtitle1);
        this.subtitle2 = new Field<string>(4, data.Subtitle2);
        this.description = new Field<string>(5, data.Description);

        if (data.Price.trim().length == 0) {
            data.Price = "0";
        }

        this.price = new Field<number>(6, parseInt(data.Price));

        let thumbPath = typeof data['ThumbPath'] !== 'undefined' ? data.ThumbPath : (typeof data['Thumbpath'] !== 'undefined' ? data['Thumbpath'] : (typeof data['thumbpath'] !== 'undefined' ? data['thumbpath'] : ""));
        let thumbPath1 = typeof data['ThumbPath01'] !== 'undefined' ? data.ThumbPath01 : (typeof data['Thumbpath01'] !== 'undefined' ? data['Thumbpath01'] : (typeof data['thumbpath01'] !== 'undefined' ? data['thumbpath01'] : ""));
        let thumbPath2 = typeof data['ThumbPath02'] !== 'undefined' ? data.ThumbPath02 : (typeof data['Thumbpath02'] !== 'undefined' ? data['Thumbpath02'] : (typeof data['thumbpath02'] !== 'undefined' ? data['thumbpath02'] : ""));
        let renderPath = typeof data['RenderPath'] !== 'undefined' ? data.RenderPath : (typeof data['Renderpath'] !== 'undefined' ? data['Renderpath'] : (typeof data['renderpath'] !== 'undefined' ? data['renderpath'] : ""));
        let renderPath1 = typeof data['RenderPath01'] !== 'undefined' ? data.RenderPath01 : (typeof data['RenderPath01'] !== 'undefined' ? data['RenderPath01'] : (typeof data['renderpath01'] !== 'undefined' ? data['renderpath01'] : ""));
        let renderPath2 = typeof data['RenderPath02'] !== 'undefined' ? data.RenderPath02 : (typeof data['RenderPath02'] !== 'undefined' ? data['RenderPath02'] : (typeof data['renderpath02'] !== 'undefined' ? data['renderpath02'] : ""));
        this.thumbPath = new Field<string>(7, thumbPath);
        this.thumbPath1 = new Field<string>(8, thumbPath1);
        this.thumbPath2 = new Field<string>(9, thumbPath2);
        this.renderPath = new Field<string>(10, renderPath);
        this.renderPath1 = new Field<string>(11, renderPath1);
        this.renderPath2 = new Field<string>(12, renderPath2);
        this.url = new Field<string>(13, data.url);
        // init filterBy fields
        this.filterBy.forEach((type) => {
            if (typeof data[type] !== "undefined") {
                this.filters.push({ type: type, value: data[type] });
            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/model/product.ts